(function () {
  'use strict';

  let clickTimeout;

  const getTabTarget = (e) => {
    const { target } = e;

    let tab;

    if (target) {
      tab = target;

      while (1) {
        if (tab.classList && tab.classList.contains('link-item') && tab.hasAttribute('tabindex')) {
          break;
        } else if (tab.parentNode) {
          tab = tab.parentNode;
        } else {
          tab = false;
          break;
        }
      }
    }

    return tab;
  };

  const getMenuTarget = (e) => {
    const { target } = e;

    let menu;

    if (target) {
      menu = target;

      while (1) {
        if (menu.classList && menu.classList.contains('megamenu-item')) {
          break;
        } else if (menu.parentNode) {
          menu = menu.parentNode;
        } else {
          menu = false;
          break;
        }
      }
    }

    return menu;
  };

  const clearClick = () => {
    if (clickTimeout) {
      clearTimeout(clickTimeout);
    }
  };

  const initMenu = () => {
    document.querySelector('.link-list').addEventListener('mouseover', (e) => {
      const tab = getTabTarget(e);
      const menu = getMenuTarget(e);

      if (tab) {
        clearClick();
        e.stopPropagation();

        const menu = tab.nextElementSibling;
        if (menu && !menu.classList.contains('active')) {
          tab.click();
        }
      } else if (menu) {
        clearClick();
      } else {
        const activeMenu = document.querySelector('.megamenu-item.active');

        if (activeMenu) {
          clearClick();
          clickTimeout = setTimeout(() => activeMenu.previousElementSibling.click(), 100);
        }
      }
    });

    document.querySelector('.link-list').addEventListener('mouseout', (e) => {
      const tab = getTabTarget(e);
      const menu = getMenuTarget(e);

      if (tab) {
        clearClick();
        e.stopPropagation();

        const tabMenu = tab.nextElementSibling;
        if (tabMenu && tabMenu.classList.contains('active')) {
          clickTimeout = setTimeout(() => tab.click(), 100);
        }
      } else if (menu) {
        clearClick();
        e.stopPropagation();
        clickTimeout = setTimeout(() => menu.previousElementSibling.click(), 100);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener('DOMContentLoaded', initMenu);
  } else {
    initMenu();
  }
})();